/** 与 AppFactory inductionBankPolicy 同形；前端展示/估算用。 */

export const DEFAULT_INDUCTION_BANK_MEMBER_RATIO = 10;

/** 与 AppFactory 一致：每槽参考原题上限。 */
export const DEFAULT_INDUCTION_REFERENCE_SAMPLE_CAP = 3;

export const INDUCTION_BANK_MEMBER_RATIO_DESCRIPTION =
  '诱导压缩率：目标诱导题数 = min(原生入围 L, max(⌈L÷memberRatio⌉, 1))；'
  + `每槽随机抽 min(目标, ${DEFAULT_INDUCTION_REFERENCE_SAMPLE_CAP}) 道原题+PAP 摘要作参考（轻量综合出题）。`;

export function normalizeInductionBankMemberRatio(raw: unknown): number {
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 2) return DEFAULT_INDUCTION_BANK_MEMBER_RATIO;
  return Math.min(100, Math.floor(n));
}

export function readInductionBankMemberRatio(
  meta: Record<string, unknown> | null | undefined,
): number {
  const raw = meta?.inductionBankPolicy;
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    return normalizeInductionBankMemberRatio((raw as Record<string, unknown>).memberRatio);
  }
  return DEFAULT_INDUCTION_BANK_MEMBER_RATIO;
}

export function inductionTargetByMembers(
  memberCount: number,
  memberRatio?: number,
): number {
  const n = Math.max(0, Math.floor(Number(memberCount) || 0));
  if (n <= 0) return 0;
  const ratio = normalizeInductionBankMemberRatio(
    memberRatio ?? DEFAULT_INDUCTION_BANK_MEMBER_RATIO,
  );
  return Math.min(n, Math.max(1, Math.ceil(n / ratio)));
}

/**
 * 每槽参考题数：相对 bank 目标再压到 cap（默认 3），仍综合出题。
 * sample = min(L, max(1, min(cap, ⌈L/ratio⌉)))
 */
export function inductionReferenceSampleSize(
  memberCount: number,
  memberRatio?: number,
  sampleCap: number = DEFAULT_INDUCTION_REFERENCE_SAMPLE_CAP,
): number {
  const bank = inductionTargetByMembers(memberCount, memberRatio);
  if (bank <= 0) return 0;
  const cap = Math.max(1, Math.floor(Number(sampleCap) || DEFAULT_INDUCTION_REFERENCE_SAMPLE_CAP));
  const n = Math.max(0, Math.floor(Number(memberCount) || 0));
  return Math.min(n, Math.max(1, Math.min(cap, bank)));
}

export function formatInductionRatioLabel(memberRatio?: number): string {
  const r = normalizeInductionBankMemberRatio(memberRatio);
  return `min(L, ⌈原生÷${r}⌉)`;
}
